import { baseURL } from './http.js';
import request from './request.js';
export default {
  professionalServiceList: item => request(baseURL).post('wishProfessionalService/listPage', item),
  professionalServiceCreate: item => request(baseURL).post('wishProfessionalService/create', item),
  professionalServiceUpdate: item => request(baseURL).post('wishProfessionalService/update', item),
  professionalServiceDelete: item => request(baseURL).post('wishProfessionalService/deleteByIds', item),
  professionalServiceGet: id => request(baseURL).get(`wishProfessionalService/get?id=${id}`),
  itList: item => request(baseURL).post('wishIt/listPage', item),
  itCreate: item => request(baseURL).post('wishIt/create', item),
  itUpdate: item => request(baseURL).post('wishIt/update', item),
  itDelete: item => request(baseURL).post('wishIt/deleteByIds', item),
  itGet: id => request(baseURL).get(`wishIt/get?id=${id}`),
  materielList: item => request(baseURL).post('wishMateriel/listPage', item),
  materielCreate: item => request(baseURL).post('wishMateriel/create', item),
  materielUpdate: item => request(baseURL).post('wishMateriel/update', item),
  materielDelete: item => request(baseURL).post('wishMateriel/deleteByIds', item),
  materielGet: id => request(baseURL).get(`wishMateriel/get?id=${id}`),
  checkIsExist: item => request(baseURL).get(`employee/getFeishuDepartmentSingleName?flowerName=${item}`),
}